import React, { useState } from 'react'
import { RedTooltipBox } from './RedTooltipBox'
interface TooltipIconProps {
  tooltipText: string | number
}

const RedTooltipIcon: React.FC<TooltipIconProps> = ({ tooltipText }) => {
  const [expanded, setExpanded] = useState(false)

  const handleMouseEnter = (): void => {
    setExpanded(true)
  }

  const handleMouseLeave = (): void => {
    setExpanded(false)
  }

  if (!tooltipText) {
    return null
  }

  return (
    <div
      className=" w-full"
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <div
        className="w-6 h-6 ml-2 rounded-full bg-red-500 text-white flex justify-center items-center text-xs font-bold"
      >
        {tooltipText}
      </div>
      <div>
        {expanded && <RedTooltipBox text={`${tooltipText} unresolved errors`} />}
      </div>
    </div>
  )
}

export default RedTooltipIcon
